export const SET_AUTHENTICATION = '[mutations] set authentication';
export const IS_USER_AUTHENTICATED = '[getters] is user authenticated';
export const SET_SELLER = '[mutations] set seller';
export const GET_SELLER = '[getters] get seller';